import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

/**
 * Animate
 * 动画处理器
 * 滤境管理
 *
 * Animate 时间组成
 * [1.---delay---][1.---duration---][1.---repeatDelay---][2.---duration---]
 * repeatDelay 跟在时间后面；
 * 总时间 totalTime: delay + duration * (repeat + 1) + repeatDelay * repeat;
 *
 * 回调事件处理
 * repeat = 0:
 * [---delay---][---onStart(0)---][---onUpdate(duration)---][---onComplete(totalTime)---]
 * repeat = 2:
 * 1.[---delay---][---onStart(0)---][---onUpdate(duration)---][---repeatDelay---]
 * 2.[---onRepeat(0)---][---onUpdate(duration)---][---repeatDelay---]
 * 3.[---onRepeat(0)---][---onUpdate( duration)---][---onComplete(totalTime)---]
 *
 */
import { initAnimProps, getDefaultStart, getValue, getStartAtValue, flatArray, shadowExp } from '../utils';
import ease from './ease';
import { Plugins } from '../';

var Element = /*#__PURE__*/function () {
  function Element(_item) {
    var _this = this;

    _classCallCheck(this, Element);

    this.item = void 0;
    this.vars = {};
    this.start = void 0;
    this.parent = void 0;
    this.root = void 0;
    this.startAt = {};
    this.mode = void 0;
    this.appearTo = 0;
    this.props = {};
    this.index = void 0;
    this.register = void 0;
    this.reverseStart = void 0;
    this.repeatNum = 0;
    this.prevMoment = void 0;
    this.easing = void 0;

    this.changeValueToVars = function (k, value, skipPlugin) {
      var isArray = (Array.isArray(value) || k.match(/color|fill|stroke/i) || k.match(shadowExp) && typeof value === 'string' || typeof value === 'string' && value.split(/[\s|,]/).length > 1) && !(k in Plugins);

      if (k in Plugins || isArray) {
        if (skipPlugin) {
          return value;
        }

        return {
          value: value,
          plugins: [],
          array: isArray
        };
      }

      var vars = parseFloat(value.toString().replace(/=/g, ''));
      var unit = value.toString().replace(/[^a-z|%]/g, ''); // +=, -= 匹配

      var count = value.toString().charAt(1) === '=' ? value.toString().replace(/[^\+\=|\-\=]/gi, '') : ''; // const startUnit = (this.startAt[k] && this.startAt[k].unit) || '';
      // console.log(unit, startUnit);

      /* if (
        unit !== startUnit &&
        this.startAt[k] &&
        this.startAt[k].vars !== getDefaultStart(k)
      ) {
        console.warn(
          `Warning: animation vars(${value}) units(${unit ||
            'px'}) are not equal to startAt(${startUnit || 'px'}).`,
        );
      } */

      return {
        vars: vars,
        unit: unit,
        count: count
      };
    };

    this.setEase = function (e) {
      if (typeof e === 'function') {
        _this.easing = e;
        return;
      } else if (e.match(/,/g)) {
        _this.easing = ease.path(e);
        return;
      }

      _this.easing = ease[e];
    };

    this.getTotalTime = function () {
      var _this$props = _this.props,
          _this$props$duration = _this$props.duration,
          duration = _this$props$duration === void 0 ? 450 : _this$props$duration,
          _this$props$delay = _this$props.delay,
          delay = _this$props$delay === void 0 ? 0 : _this$props$delay,
          _this$props$repeat = _this$props.repeat,
          repeat = _this$props$repeat === void 0 ? 0 : _this$props$repeat,
          _this$props$repeatDel = _this$props.repeatDelay,
          repeatDelay = _this$props$repeatDel === void 0 ? 0 : _this$props$repeatDel;
      return repeat === -1 ? Number.MAX_VALUE : delay + duration * (repeat + 1) + repeatDelay * repeat;
    };

    this.getEaseToRatio = function (r, isFrom) {
      var _this$props$ease = _this.props.ease,
          ease = _this$props$ease === void 0 ? '' : _this$props$ease;
      return (r === 0 || r === 1) && !(typeof ease === 'function' || ease.match(/,/g)) ? r : _this.easing(isFrom ? 1 - r : r, isFrom ? 1 : 0, isFrom ? 0 : 1, 1);
    };

    this.setRatioToVars = function (ratio) {
      var vars = _this.vars,
          root = _this.root;

      for (var i = 0; i < root.targets.length; i++) {
        if (!root.targets[i]) {
          continue;
        } // root.targets.forEach((_, i) => {


        for (var key in vars) {
          // Object.keys(vars).forEach((key: string) => {
          var item = vars[key];

          if (item.plugins) {
            if (key === 'PathMotion') {
              // pathMotion 的属性与 style 通用。不需新增；
              root.vars[i].style = item.plugins[i].render(ratio);
            } else {
              root.vars[i][key] = item.plugins[i].render(ratio);
            }

            continue;
          }

          var endVars = item.vars,
              count = item.count,
              unit = item.unit;
          var startVars = _this.start[i][key];
          root.vars[i][key] = getValue(startVars, endVars, ratio, count, unit); //});
        } //});

      }
    };

    this.onRegisterAnimate = function () {
      _this.register = true;
      var root = _this.root,
          parent = _this.parent,
          startAt = _this.startAt;
      var start = [];

      for (var i = 0; i < root.targets.length; i++) {
        var target = root.targets[i];
        var vars = root.vars[i];
        var s = {};

        for (var key in _this.vars) {
          var cItem = _this.vars[key];

          if (cItem.plugins) {
            var plugin = new Plugins[cItem.array ? 'ArrayPlugin' : key](cItem.value, key);
            plugin.target = target;
            plugin.root = root;
            plugin.parent = parent;
            plugin.targetIndex = i;
            plugin.tweenVars = vars;
            plugin.index = _this.index;
            plugin.startAt = startAt;
            s[key] = plugin.getAnimStart();
            cItem.plugins.push(plugin);
          } else {
            var _ref, _startAt$key;

            var targetValue = (_ref = root.attr ? target.getAttribute(key) : vars[key] || target[key]) !== null && _ref !== void 0 ? _ref : getDefaultStart(key);
            var startData = (_startAt$key = startAt[key]) !== null && _startAt$key !== void 0 ? _startAt$key : targetValue; // root.vars[i][key] ??

            var isStartAt = _typeof(startData) === 'object' && 'vars' in startData && 'count' in startData;
            var unit = isStartAt ? startData.unit : "".concat(startData).replace(/[^a-z|%]/g, '');
            var varsUnit = cItem.unit;

            if (unit && unit !== varsUnit) {
              console.warn("Different units, start unit ".concat(unit, ", to value unit ").concat(varsUnit, ", remove start unit."));
            }

            s[key] = isStartAt ? getStartAtValue(targetValue, startData) : parseFloat(startData);
          }
        }

        start.push(s);
      }

      _this.start = start;
    };

    this.overflowRatio = function (ratio) {
      var r = ratio < 0 ? 0 : ratio;
      var duration = _this.props.duration;
      r = r > duration ? duration : r;
      return r;
    };

    this.render = function (_ref2) {
      var moment = _ref2.moment,
          _ref2$fps = _ref2.fps,
          fps = _ref2$fps === void 0 ? 0 : _ref2$fps,
          silence = _ref2.silence,
          render = _ref2.render;
      var parent = _this.parent,
          root = _this.root,
          props = _this.props;
      var targets = flatArray(root.targets);
      var onChange = parent.onChange;
      var _props$repeat = props.repeat,
          repeat = _props$repeat === void 0 ? 0 : _props$repeat;
      var _props$type = props.type,
          type = _props$type === void 0 ? 'to' : _props$type,
          _props$duration = props.duration,
          duration = _props$duration === void 0 ? 450 : _props$duration,
          _props$delay = props.delay,
          delay = _props$delay === void 0 ? 0 : _props$delay,
          _props$repeatDelay = props.repeatDelay,
          repeatDelay = _props$repeatDelay === void 0 ? 0 : _props$repeatDelay,
          yoyo = props.yoyo;
      repeat = repeat === -1 ? Number.MAX_VALUE : repeat;
      var ratio = moment - delay; // const totalTime = duration + delay;

      var repeatNum = Math.floor(ratio / (duration + repeatDelay)) || 0;
      repeatNum = repeatNum > repeat ? repeat : repeatNum;
      repeatNum = repeatNum < 0 ? 0 : repeatNum;
      ratio = ratio - (duration + repeatDelay) * repeatNum;
      /**
       * 反向播放 isFrom 与 yoyoReverse 的区别
       * 反向播放: isFrom
       * [---delay---][---isFrom duration---]
       * yoyo
       * [---duration---][---delay---]
       * backwards
       * 两个都为 true 时为 false;
       */

      var yoyoReverse = !!(yoyo && repeatNum % 2);
      var isFrom = type === 'from';
      var backwards = yoyoReverse && isFrom ? false : yoyoReverse || isFrom;
      ratio = backwards ? duration - ratio : ratio;
      var fromDelay = isFrom ? 0 : delay;
      var r = backwards ? 1 : 0; // 0 进入时的注册

      if (!_this.register && moment >= fromDelay) {
        _this.onRegisterAnimate(); // 时间超出当前动画时间的处理


        if (backwards && ratio <= 0 || !backwards && ratio >= duration && duration) {
          // this.mode = 'onComplete';
          _this.prevMoment = moment;
          r = backwards ? 0 : 1;
        }

        _this.setRatioToVars(r); // 初始注册，改变外部 vars;


        onChange({
          index: _this.index,
          vars: root.vars
        });
      }

      if (_this.register && moment > delay - fps && moment < _this.totalTime + fps) {
        ratio = _this.overflowRatio(ratio);
        r = backwards ? 1 : 0;

        if (moment >= _this.totalTime && _this.mode !== 'onComplete' && _this.prevMoment !== undefined || _this.prevMoment === undefined && moment >= _this.totalTime && duration) {
          r = backwards ? 0 : 1;
          _this.mode = 'onComplete';

          if (_this.props.onComplete) {
            _this.props.onComplete({
              mode: _this.mode,
              index: _this.index,
              moment: ratio,
              ratio: r,
              targets: targets,
              vars: flatArray(root.vars)
            });
          }
        } else if (_this.prevMoment === undefined || moment <= 0 && moment > -fps && _this.mode !== 'onStart' && _this.prevMoment > moment) {
          _this.mode = 'onStart';

          if (_this.props.onStart) {
            _this.props.onStart({
              mode: _this.mode,
              index: _this.index,
              moment: ratio,
              ratio: r,
              targets: targets,
              vars: flatArray(root.vars)
            });
          }
        } else {
          r = ratio && duration ? ratio / duration : 0;
          _this.mode = 'onUpdate';

          if (_this.props.onUpdate) {
            _this.props.onUpdate({
              mode: _this.mode,
              index: _this.index,
              moment: ratio,
              ratio: r,
              targets: targets,
              vars: flatArray(root.vars)
            });
          }
        }

        if (repeat && repeatNum !== _this.repeatNum && moment && _this.mode === 'onUpdate') {
          _this.mode = 'onRepeat';

          if (_this.props.onRepeat) {
            _this.props.onRepeat({
              mode: _this.mode,
              index: _this.index,
              moment: ratio,
              ratio: r,
              targets: targets,
              vars: flatArray(_this.root.vars)
            });
          }
        }

        _this.setRatioToVars(_this.getEaseToRatio(r, isFrom));

        if (repeat) {
          _this.repeatNum = repeatNum;
        }

        var cb = {
          mode: _this.mode,
          moment: ratio,
          repeat: repeatNum,
          ratio: r,
          targets: root.targets,
          vars: root.vars,
          index: _this.index
        };

        if (silence) {
          cb.silence = silence;
        }

        if (render) {
          cb.render = render;
        }

        onChange(cb);
        _this.prevMoment = moment;
      }
    };

    this.item = _item; // delete item.appearTo;

    this.startAt = _objectSpread({}, _item.startAt);
    Object.keys(this.startAt).forEach(function (c) {
      _this.startAt[c] = _this.changeValueToVars(c, _this.startAt[c], true);
    }); // delete item.startAt;

    var _props = {};

    for (var k in _item) {
      var value = _item[k];

      if (!(k in initAnimProps)) {
        this.vars[k] = this.changeValueToVars(k, value);
      } else {
        _props[k] = value;
      }
    }

    this.props = _objectSpread(_objectSpread({}, initAnimProps), _props);
    this.setEase(this.props.ease);
  }

  _createClass(Element, [{
    key: "totalTime",
    get: // parentBackwards?: boolean;
    function get() {
      return this.getTotalTime();
    }
  }]);

  return Element;
}();

export { Element as default };